import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import Link from '@/components/utils/Link';
import { URL } from '@/constants';
import { i18n } from '../DeltaAdvPC/i18n';
import { useRouter } from 'next/router';

export default function AARS({ theme = 'black', local = 'us' }) {
    const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN } = URL;
    const getAppDataLayer = (type: string) => ({
        event: 'uaEvent',
        event_name: 'ecoflow_app',
        button_name: type,
    });
    const { locale = 'us' } = useRouter();
    const {
        title,
        desc,
        item1_subtitle,
        item1_title,
        item1_desc,
        item2_subtitle,
        item2_title,
        item2_desc,
        item3_subtitle,
        item3_title,
        item3_desc,
        list1_subtitle,
        list1_title,
        list1_desc,
        list2_title,
        list2_desc,
        list3_title,
        list3_desc,
        tip,
    } = i18n[locale] || i18n['en'];

    const senceList = [
        {
            subTitle: list1_subtitle,
            title: list1_title,
            desc: list1_desc,
            img: locale === 'ph' ? 'https://websiteoss.ecoflow.com/upload/image/1751082188563/3.jpg' : require('@publicLocal/app-point/pc/rs_adv_4.jpg'),
        },
        {
            subTitle: '',
            title: list2_title,
            desc: list2_desc,
            img: locale === 'ph' ? 'https://websiteoss.ecoflow.com/upload/image/1751082188380/1.jpg' : require('@publicLocal/app-point/pc/rs_adv_5.jpg'),
        },
        {
            subTitle: '',
            title: list3_title,
            desc: list3_desc,
            img: require('@publicLocal/app-point/pc/rs_adv_6.jpg'),
        },
    ];

    const getRiver2Optimization = () => {
        const needSenceList = senceList.splice(0, 1);
        senceList.push(needSenceList[0]);
        senceList[0].subTitle = list1_subtitle;
        senceList[2].subTitle = '';
        return senceList;
    };

    return (
        <div
            className={`${css.AARS} app-adv-rs`}
            style={{
                background: theme == 'black' ? '#000' : 'unset',
            }}
        >
            <div className={`content-wrapper ${theme}`}>
                <p className="title">{title}</p>
                <p className="desc">{desc}</p>
                <div className="img-wrapper-small">
                    <div className="panel">
                        <NextImage src={require('@publicLocal/app-point/pc/rs_adv_1.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        <div className="text-wrapper">
                            <p className="sub-title">{item1_subtitle}</p>
                            <p className="title">{item1_title}</p>
                            <p className="desc">{item1_desc}</p>
                        </div>
                    </div>
                    <div className="panel">
                        <NextImage
                            src={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751082188747/2.png'
                                    : require('@publicLocal/app-point/pc/rs_adv_2.jpg')
                            }
                            alt={'EcoFlow app'}
                            aria-label={'EcoFlow app'}
                        />
                        <div className="text-wrapper">
                            <p className="sub-title">{item2_subtitle}</p>
                            <p className="title">{item2_title}</p>
                            <p className="desc">{item2_desc}</p>
                        </div>
                    </div>
                    <div className="panel">
                        <NextImage src={require('@publicLocal/app-point/pc/rs_adv_3.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        <div className="text-wrapper">
                            <p className="sub-title">{item3_subtitle}</p>
                            <p className="title">{item3_title}</p>
                            <p className="desc">{item3_desc}</p>
                        </div>
                    </div>
                </div>
                <div className="img-wrapper-big">
                    {getRiver2Optimization().map((item: any, index: number) => (
                        <div className="panel" key={index}>
                            <div className="left">
                                <p className="sub-title">{item.subTitle}</p>
                                <p className="title">{item.title}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                            <div className="right">
                                <NextImage src={item.img} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="download-wrapper">
                    <p>{tip}</p>
                    <div className="icons">
                        <Link href={APP_IOS} dataLayer={getAppDataLayer('App Store')}>
                            <NextImage src={require('@publicLocal/app-point/app_store.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                        <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                            <NextImage src={require('@publicLocal/app-point/google_play.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
